enum EApiMiddlewareMethod {
  DELETE = 'DELETE',
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
}
export default EApiMiddlewareMethod;
